import { get } from 'lodash';

import {
  SET_ORDER_STEP,
  SET_LAST_TRANSACTION,
  SET_TRANSACTION_DETAILS,
  CLEAR_TRANSACTION_DETAILS,
  SET_ORDER_ID,
  SET_VEND_DETAILS,
  SET_CARDS,
  SET_CURRENT_SERVICE,
  SET_SERVICE_DISTRIBUTION
} from '../actions/orderActions';

const getUrlParam = (paramName) => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(paramName);
};

const defaultService = 'electricity';
const productQueryParam = getUrlParam('product');
const initialService = ['tv', 'airtime', 'data'].includes(productQueryParam)
  ? productQueryParam
  : defaultService;

const initOrderState = {
  step: 1,
  stage: 'create',
  orderId: '',
  lastTransaction: {},
  transactionDetails: {},
  vendDetails: {},
  cards: [],
  currentService: initialService,
  serviceDistribution: {
    data: {},
    meta: {},
  },
};

export default (state = initOrderState, action) => {
  switch (action.type) {
    case SET_ORDER_STEP:
      return {
        ...state,
        stage: action.stage || state.stage,
        step: action.step || state.step,
      };

    case SET_LAST_TRANSACTION:
      return {
        ...state,
        lastTransaction: action.data,
      };

    case SET_TRANSACTION_DETAILS:
      return {
        ...state,
        transactionDetails: { ...state.transactionDetails, ...action.data },
      };

    case CLEAR_TRANSACTION_DETAILS:
      return {
        ...state,
        orderId: '',
        transactionDetails: {},
      };

    case SET_ORDER_ID:
      return {
        ...state,
        orderId: action.id,
        transactionDetails: {
          ...(state.transactionDetails || {}),
          orderId: action.id,
        },
      };

    case SET_VEND_DETAILS:
      return {
        ...state,
        vendDetails: action.data,
      };

    case SET_CARDS:
      return {
        ...state,
        transactionDetails: {
          ...(state.transactionDetails || {}),
          paymentData: {
            ...(state.transactionDetails.paymentData || {}),
            methods: (get(state, 'transactionDetails.paymentData.methods', [])).map((f) => {
              if (f.title.toLowerCase() === 'authorized cards') {
                f.options.cards = action.data || [];
                return f;
              }
              return f;
            }),
          },
        },
      };

    case SET_CURRENT_SERVICE: {
      return {
        ...state,
        currentService: action.service
      }
    }

    case SET_SERVICE_DISTRIBUTION: {
      return {
        ...state,
        serviceDistribution: action.data,
      }
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/orderReducer.js